import styled from '@emotion/styled';
import { rgba } from 'polished';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const TableWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
  }),
);

export const Table = styled.table(() =>
  mq({
    border: 'solid #323332',
    borderWidth: '1px 0',
  }),
);

export const TableHeader = styled.th(() =>
  mq({
    height: '30px',
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'inherit',
    backgroundColor: defaultTheme.background.mediumGray,
    verticalAlign: 'middle',
    textAlign: 'center',
    border: `solid ${defaultTheme.border.color.black}`,
    borderWidth: '1px 0',
  }),
);

export const TableData = styled.td(
  (props: { span?: number; disabled?: boolean }) =>
    mq({
      width: ['40px', '40px', '50px', '50px'],
      height: props.span ? `${50 * props.span}px` : '50px',
      verticalAlign: 'middle',
      borderBottom: `1px solid ${defaultTheme.border.color.black}`,
      backgroundColor: props.disabled
        ? rgba(defaultTheme.background.darkGray, 0.3)
        : defaultTheme.background.white,
    }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
  }),
);

export const ActionButtons = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: ['40px', '40px', '50px', '50px'],
    margin: `${defaultTheme.spacing.s} 0`,
    button: {
      width: ['35px', '35px', '40px', '40px'],
      height: ['35px', '35px', '40px', '40px'],
      marginBottom: defaultTheme.spacing.xs,
    },
  }),
);
